var map = {
	"./frontend/AndroidGuide.vue": 14529,
	"./frontend/Banking.vue": 38194,
	"./frontend/BetslipHistory.vue": 73756,
	"./frontend/BodyFB.vue": 80944,
	"./frontend/Commission.vue": 56717,
	"./frontend/ContactUs.vue": 94493,
	"./frontend/DataTable.vue": 36107,
	"./frontend/Deposit.vue": 31310,
	"./frontend/History.vue": 79272,
	"./frontend/Home.vue": 80331,
	"./frontend/IOSGuide.vue": 99739,
	"./frontend/Iframe copy.vue": 34991,
	"./frontend/Iframe.vue": 42384,
	"./frontend/Index.vue": 76722,
	"./frontend/Live.vue": 31445,
	"./frontend/LiveScore.vue": 72184,
	"./frontend/MainMenu.vue": 30199,
	"./frontend/MatchResult.vue": 80973,
	"./frontend/MaungFB.vue": 36378,
	"./frontend/Promotion.vue": 1786,
	"./frontend/Setting.vue": 91233,
	"./frontend/VideoLink.vue": 73379,
	"./frontend/VipLevels.vue": 58073,
	"./frontend/Withdraw.vue": 37300,
	"./frontend/auth/Login.vue": 25376,
	"./frontend/auth/Register.vue": 84636,
	"./frontend/auth/Rule.vue": 24557,
	"./frontend/auth/Verify.vue": 80890,
	"./frontend/auth/VerifyNotAuth.vue": 40460,
	"./frontend/components/AccountSelect.vue": 5056,
	"./frontend/components/AppHeader.vue": 92709,
	"./frontend/components/DataTable.vue": 14954,
	"./frontend/components/FBPreviewVoucher.vue": 45909,
	"./frontend/components/FBVoucher.vue": 70718,
	"./frontend/components/FootballTeamCard.vue": 67236,
	"./frontend/components/GroupBox.vue": 48747,
	"./frontend/components/InputSelectDrawModal.vue": 90313,
	"./frontend/components/LuckyWheel.vue": 93731,
	"./frontend/components/NormalBox.vue": 63243,
	"./frontend/components/PreviewVoucher.vue": 28456,
	"./frontend/components/SideNav.vue": 30850,
	"./frontend/components/Table.vue": 53683,
	"./frontend/components/ThreedGroupBox.vue": 95959,
	"./frontend/components/TwoDSelect.vue": 89795,
	"./frontend/components/Voucher.vue": 46114,
	"./frontend/normal-user/2d/2d.vue": 52131,
	"./frontend/normal-user/2d/ClosedDays.vue": 85909,
	"./frontend/normal-user/2d/Home.vue": 18626,
	"./frontend/normal-user/2d/Winner.vue": 70630,
	"./frontend/normal-user/3d/3d.vue": 21346,
	"./frontend/normal-user/3d/Home.vue": 45295,
	"./frontend/normal-user/DreamBooks.vue": 46314,
	"./frontend/normal-user/Index.vue": 56012,
	"./frontend/normal-user/bugyee/Room.vue": 6472,
	"./frontend/normal-user/game/Arcade.vue": 23307,
	"./frontend/normal-user/game/Fishing.vue": 96908,
	"./frontend/normal-user/game/Game.vue": 45362,
	"./frontend/normal-user/game/Slot.vue": 98045,
	"./frontend/normal-user/shankomee/Room.vue": 52386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;